export const DEFAULT_LANGUAGE_ENGLISH = {value: "en", label: "English", isRtl: false};
export let LANGUAGE_MASTER = [
];
export const LANGUAGE_LABELS = {
  en: "English",
  hi: "हिंदी",
  mr: "मराठी",
  kn: "ಕನ್ನಡ",
  ta: "தமிழ்",
  bn: "বাংলা",
  te: "తెలుగు",
  zh: "中文",
  ms: "Malay"
};
export let LANGUAGE_OPTIONS = [...LANGUAGE_MASTER];